import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo.svg';

const NAV_ITEMS = [
  { label: 'Features', href: '#features' },
  { label: 'Audience', href: '#audience' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
];

function Navbar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);

      // Show/hide navbar based on scroll direction
      if (window.scrollY > lastScrollY.current && window.scrollY > 100) {
        // scrolling down
        setVisible(false);
      } else {
        // scrolling up
        setVisible(true);
      }
      lastScrollY.current = window.scrollY;

      // Track active section
      const sections = NAV_ITEMS.map(item => document.querySelector(item.href));
      const scrollPos = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const sec = sections[i];
        if (sec && sec.offsetTop <= scrollPos) {
          setActiveSection(NAV_ITEMS[i].href.substring(1));
          break;
        }
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock/unlock body scroll when menu opens/closes
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isMobileMenuOpen]);

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`nav${scrolled ? ' scrolled' : ''}${visible ? ' visible' : ' hidden'}`}>
        <div className="nav-container">
          <div className="nav-wrapper">
            <a href="#hero" className="nav-brand" onClick={e => handleLinkClick(e, '#hero')}>
              <img src={logo} alt="BOSS Logo" className="nav-logo" />            
            </a>

            <div className="nav-menu">
              {NAV_ITEMS.map(item => (
                <a
                  key={item.href}
                  href={item.href}
                  className={activeSection === item.href.substring(1) ? 'active' : ''}
                  onClick={e => handleLinkClick(e, item.href)}
                >
                  {item.label}
                </a>
              ))}
            </div>

            <div className="nav-actions">
              <Link to="/login" className="nav-cta-btn">
                Start Free Trial
              </Link>
            </div>

            <button
              className="mobile-menu-btn"
              aria-label="Toggle menu"
              onClick={toggleMobileMenu}
            >
              <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>
      </nav>

      {/* Full Screen Mobile Menu - Clean White Design */}
      <div className={`mobile-menu${isMobileMenuOpen ? ' open' : ''}`}>
        <button 
          className="mobile-menu-close"
          onClick={closeMobileMenu}
          aria-label="Close menu"
        >
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="mobile-menu-content">
          <div className="mobile-menu-items">
            {NAV_ITEMS.map(item => (
              <a
                key={item.href}
                href={item.href}
                className={activeSection === item.href.substring(1) ? 'active' : ''}
                onClick={e => handleLinkClick(e, item.href)}
              >
                {item.label}
              </a>
            ))}
          </div>
          
          <div className="mobile-menu-actions">
            <Link 
              to="/login" 
              className="nav-cta-btn mobile" 
              onClick={closeMobileMenu}
            >
              Start Free Trial
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;